import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid";
import { Typography } from "@material-ui/core";
import { camelCase, startCase } from "lodash";
import RequireWorkarea from "components/RequireWorkarea";
import RequireOrganization from "components/RequireOrganization";
import { soloNotSupported } from "util/solo";
import FilesListCard from "./FilesListCard";
import CastsInFileCard from "./CastsInFileCard";
import FilesFilterCard from "./FilesFilterCard";

const ConfirmLayout = props =>
  soloNotSupported(props.workarea, props.organization) ? (
    <Typography variant="h6" style={{ textAlign: "center" }}>
      Solo tools are not supported for the combination of{" "}
      {startCase(camelCase(props.organization))} organization and{" "}
      {startCase(camelCase(props.workarea))} workarea.
    </Typography>
  ) : (
    <RequireOrganization {...props}>
      <RequireWorkarea {...props}>
        <Row>
          <Col xs={12}>
            <FilesFilterCard {...props} />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <FilesListCard {...props} />
          </Col>
        </Row>

        {props.soloFilesBeingConfirmed.length > 0 && (
          <Row style={{ marginTop: "1rem" }}>
            <Col xs={12}>
              <CastsInFileCard {...props} />
            </Col>
          </Row>
        )}
      </RequireWorkarea>
    </RequireOrganization>
  );

ConfirmLayout.propTypes = {
  soloFilesBeingConfirmed: PropTypes.arrayOf(PropTypes.number),
  workarea: PropTypes.string,
  organization: PropTypes.string
};

ConfirmLayout.defaultProps = {
  soloFilesBeingConfirmed: [],
  workarea: null,
  organization: null
};

export default ConfirmLayout;
